import type { ToolCallDetail } from "../../agent-sdk-types.js";
import { deriveToolDetail } from "../tool-detail-registry.js";

export function deriveClaudeToolDetail(
  name: string,
  input: unknown,
  output: unknown,
): ToolCallDetail {
  return deriveToolDetail(name, input, output);
}
